<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <department>
        </department> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import Department from './todo-department'
export default {
    components: {
        Department
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-departments/base-department.vue